import { defineComponent as t, openBlock as o, createBlock as a, unref as p, mergeProps as c, withCtx as l, createElementVNode as m } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const h = /* @__PURE__ */ t({
  name: "IconCurrencyYen",
  __name: "IconCurrencyYen",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const r = n;
    return (u, e) => (o(), a(p(s), c(r, { "view-box": "0 0 20 20" }), {
      default: l(() => [...e[0] || (e[0] = [
        m("path", { d: "M6.163 1.15a.75.75 0 0 0-1.326.7l3.917 7.4H4.5a.75.75 0 0 0 0 1.5h4.75v2H4.5a.75.75 0 1 0 0 1.5h4.75v4.25a.75.75 0 0 0 1.5 0v-4.25h4.75a.75.75 0 0 0 0-1.5h-4.75v-2h4.75a.75.75 0 0 0 0-1.5h-4.254l3.917-7.4a.75.75 0 1 0-1.326-.702L10 8.397 6.163 1.15" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  h as default
};
